import {
  FETCH_UPSELLS_REQUEST,
  FETCH_UPSELLS_SUCCESS,
  FETCH_UPSELLS_FAILURE,
  ADD_UPSELL_PRODUCT_REQUEST,
  ADD_UPSELL_PRODUCT_SUCCESS,
  ADD_UPSELL_PRODUCT_FAILURE,
  REMOVE_UPSELL_PRODUCT_REQUEST,
  REMOVE_UPSELL_PRODUCT_SUCCESS,
  REMOVE_UPSELL_PRODUCT_FAILURE,
  REMOVE_UPSELL_PRODUCTS_BATCH_REQUEST,
  REMOVE_UPSELL_PRODUCTS_BATCH_SUCCESS,
  REMOVE_UPSELL_PRODUCTS_BATCH_FAILURE,
} from './actionTypes';
import { UpsellsActions, UpsellsState } from './types';

const initialState: UpsellsState = {
  pending: false,
  data: [],
  error: null,

  addPending: false,
  addError: null,

  removePending: false,
  removeError: null,
};

export const shopReducer = (state = initialState, action: UpsellsActions): UpsellsState => {
  switch (action.type) {
    case FETCH_UPSELLS_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
      };
    case FETCH_UPSELLS_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.payload.products,
        error: null,
      };
    case FETCH_UPSELLS_FAILURE:
      return {
        ...state,
        pending: false,
        data: [],
        error: action.payload.error,
      };

    case ADD_UPSELL_PRODUCT_REQUEST:
      return {
        ...state,
        addPending: true,
        addError: null,
      };
    case ADD_UPSELL_PRODUCT_SUCCESS:
      return {
        ...state,
        addPending: false,
        addError: null,
      };
    case ADD_UPSELL_PRODUCT_FAILURE:
      return {
        ...state,
        addPending: false,
        addError: action.payload.error,
      };

    case REMOVE_UPSELL_PRODUCT_REQUEST:
      return {
        ...state,
        removePending: true,
        removeError: null,
      };
    case REMOVE_UPSELL_PRODUCT_SUCCESS:
      return {
        ...state,
        removePending: false,
        removeError: null,
      };
    case REMOVE_UPSELL_PRODUCT_FAILURE:
      return {
        ...state,
        removePending: false,
        removeError: action.payload.error,
      };

    case REMOVE_UPSELL_PRODUCTS_BATCH_REQUEST:
      return {
        ...state,
        removePending: true,
        removeError: null,
      };
    case REMOVE_UPSELL_PRODUCTS_BATCH_SUCCESS:
      return {
        ...state,
        removePending: false,
        removeError: null,
      };
    case REMOVE_UPSELL_PRODUCTS_BATCH_FAILURE:
      return {
        ...state,
        removePending: false,
        removeError: action.payload.error,
      };

    default:
      return state;
  }
};
